import type { JSX } from 'react';
import { Content, Header, Page } from '@backstage/core-components';
import { IronPhoenixSystemInfo } from './IronPhoenixSystemInfo';

/** Dedicated System Info page (sidebar: /system-info). */
export function SystemInfoPage(): JSX.Element {
  return (
    <Page themeId="home">
      <Header
        title="System Info"
        subtitle="Local laptop, or dev / stage / prod cluster — image version and release alignment"
      />
      <Content>
        <IronPhoenixSystemInfo variant="page" />
      </Content>
    </Page>
  );
}
